<template>
    <div class="form-group row">
        <label
            class="col-md-3 col-xl-2 col-sm-12 col-form-label"
            :name="name"
        >
            {{ label }}
        </label>
        <div class="col-md-9 col-xl-10 col-sm-12">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                required: true,
                type: String
            },
            label: {
                required: true,
                type: String
            }
        }
    }
</script>